// 错误状态提示
export const handleNetworkError = (errStatus) => {
	const networkErrMap = {
		400: "请求错误",
		401: "未授权，请重新登录",
		403: "拒绝访问",
		404: "请求错误，未找到资源",
		500: "内部系统错误",
	};
	if (errStatus) {
		throw new Error(networkErrMap[errStatus] ?? `网络出现了点小问题，请稍后再试`);
	}
};
